import { updatebook } from "../actions";

export default function editBook(bookId, bookInfo) {
  return async function (dispatch) {
    const response = await fetch(`http://localhost:9000/books/${bookId}`, {
      method: "PATCH",
      body: JSON.stringify(bookInfo),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    });
    const book = await response.json();
    dispatch(updatebook(bookId, book));
  };
}
